import React, { createContext, useContext, useEffect, useState } from "react";

const IsMobileContext = createContext<IsMobileContextValue | null>(null);

export const IsMobileProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isMobile, setIsMobile] = useState<boolean>(() => {
        if (typeof window !== "undefined") {
            return window.innerWidth < 768; 
        }
        return false; 
    });

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const value: IsMobileContextValue = { isMobile };

    return <IsMobileContext.Provider value={value}>{children}</IsMobileContext.Provider>;
};

export const useIsMobile = () => {
    const ctx = useContext(IsMobileContext);
    if (!ctx) throw new Error("useIsMobile must be used within IsMobileProvider");
    return ctx;
};